import { runningInApp } from '../appConstants/appConstants.js';

var dayOfWeek = function () {
    var currentDate = new Date();
    var d = currentDate.getDay();
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[d];
};
var getSessionInstallation = function () {
    if (!sessionStorage) {
        return null;
    }
    try {
        var giidString = sessionStorage.getItem('app.settings.selected');
        var giidObject = giidString ? JSON.parse(giidString) : null;
        if (giidObject && giidObject.installationId) {
            return giidObject.installationId;
        }
    }
    catch (error) {
        return null;
    }
    return null;
};
var getGiidFromSLocation = function () {
    var queryParams = new URLSearchParams(window.location.search);
    return queryParams.get('installationId');
};
var getPlatform = function () {
    var userAgent = navigator.userAgent;
    if (/android/i.test(userAgent)) {
        return 'android';
    }
    if (/iPad|iPhone|iPod/.test(userAgent)) {
        return 'ios';
    }
    return 'web';
};
var addExtraInfo = function () {
    var segmentsObject = {
        platform: getPlatform(),
        dayOfTheWeek: dayOfWeek(),
        sso: runningInApp ? 'true' : 'false',
        timestamp: new Date().toISOString(),
    };
    var giid = getSessionInstallation() ||
        localStorage.getItem('lastInstallationSelected') ||
        localStorage.getItem('ArloConnecting') ||
        getGiidFromSLocation() ||
        null;
    if (giid) {
        segmentsObject.giid = giid;
    }
    if (localStorage.i18nextLng) {
        segmentsObject.siteLanguage = localStorage.i18nextLng;
    }
    if (localStorage.dealerId) {
        segmentsObject.dealerId = localStorage.dealerId;
    }
    return segmentsObject;
};

export { addExtraInfo };
